/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

function toHex(bytes: ArrayBuffer): string {
  return Array.from(new Uint8Array(bytes))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/** Full lowercase hex SHA-256 of a UTF-8 string. */
export async function sha256HexUtf8(text: string): Promise<string> {
  const data = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return toHex(digest);
}

/** First 16 hex characters of SHA-256 (UTF-8) of plain text. */
export async function sha256HexPrefix16Utf8(text: string): Promise<string> {
  const full = await sha256HexUtf8(text);
  return full.slice(0, 16);
}

/** Full lowercase hex SHA-256 of raw blob bytes (DOCX comparison). */
export async function sha256HexBlob(blob: Blob): Promise<string> {
  const buf = await blob.arrayBuffer();
  const digest = await crypto.subtle.digest('SHA-256', buf);
  return toHex(digest);
}
